var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33461 10.7908L15.3098 5.48633C16.5945 4.92881 20.9302 3.16067 20.9302 3.16067C20.9302 3.16067 22.9375 2.38014 22.7609 4.25979C22.7127 5.04032 22.2631 7.73235 21.8134 10.6633L20.4164 19.3288C20.4164 19.3288 20.304 20.6031 19.3565 20.8262C18.4091 21.0492 16.8514 20.0456 16.5784 19.8385C16.3536 19.6793 12.4032 17.1943 10.958 15.9677C10.5726 15.6332 10.1229 14.9801 11.0061 14.1996C13.0134 12.3837 15.4061 10.1058 16.8514 8.67217C17.5259 8.00315 18.1842 6.45802 15.4061 8.33766L7.55359 13.5784C7.55359 13.5784 6.65432 14.1359 4.98424 13.6262C3.31417 13.1164 1.38716 12.4952 1.38716 12.4952C1.38716 12.4952 0.0543172 11.6669 2.33461 10.7908Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.ac01bec0.svg";
export { ForwardRef as ReactComponent };